module.exports = "<p>\n  text-section-item works!\n</p>\n"